module.exports = __webpack_public_path__ + "static/media/404image.795d8beb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/404image.svg
// module id = 830
// module chunks = 0